<template>
    <ModalBase :show-modal="showModal" @close-modal="close" auto-h class="gk-modal-confirm">
        <template v-slot:titlebar>
            <TitleBar variant-class="title-modal title-modal--simple">
                <template v-slot:title>
                {{ title }}
                </template>
            </TitleBar>
        </template>

        <template v-slot:maincontent>
            <b-row>
                <b-col cols="4">
                    <AnimationItem class="anim-company" :animation="{ animationData: gekkoLockAnimation.default }" :key="'anim_success'" />
                </b-col>
                <b-col style="display: flex; align-items: center;">
                    <div>
                        <div v-if="settingsPage">
                            {{ $gettext("You must upload your digital certificate to activate this feature. Simply drag and drop your file into the area above.") }}
                        </div>
                        <div v-if="!settingsPage">
                            {{ $gettext("To send Verifactu invoices to the AEAT, please upload a digital certificate. You can do this in your account settings.") }}
                        </div>
                    </div>
                </b-col>
            </b-row>
        </template>

        <template v-slot:actions>
            <GekkoButton
                v-if="!settingsPage"
                :href="Urls['accounts_verifactu_settings']()"
                :text="$gettext('Upload certificate')"
                variant="link" />
        </template>
    </ModalBase>
</template>

<script>
import ModalBase from "@/components/base_components/ModalBase"
import GekkoButton from "@/components/GekkoButton"
import TitleBar from "@/components/TitleBar"
import * as gekkoLockAnimation from '@/css/animations/gekko-lock.json'
import AnimationItem from '@/components/dashboard/ui/AnimationItem.vue'

export default {
    name: "VerifactuMessageModal",
    components: {
        ModalBase,
        GekkoButton,
        TitleBar,
        AnimationItem
    },
    props: {
        showModal: {
            type: Boolean,
            default: false
        },
        settingsPage: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            title: this.$gettext("Upload certificate"),
            gekkoLockAnimation: gekkoLockAnimation
        }
    },
    methods: {
        close() {
            this.$emit("close")
        }
    }
}
</script>